import React from 'react';

export const GospelLensIcon = ({ className = "h-5 w-5", ...props }) => (
  <svg 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round" 
    className={className} 
    {...props}
  >
    {/* Magnifying Glass Handle */}
    <path d="m21 21-4.35-4.35" />
    {/* Magnifying Glass Circle */}
    <circle cx="11" cy="11" r="8" />
    {/* Cross inside */}
    <path d="M11 8v6" strokeWidth="2.5" className="text-primary" stroke="currentColor" />
    <path d="M8 11h6" strokeWidth="2.5" className="text-primary" stroke="currentColor" />
  </svg>
);
